// extracted by mini-css-extract-plugin
module.exports = {"headerLogo":"logo-component_headerLogo__jy_Us","logoLink":"logo-component_logoLink__2ZuxK","subtext":"logo-component_subtext__1bClu"};